import { Chip } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { setIssueReportChipColor } from './issueReport';
import { hexToRgba } from '../../utils';

interface IssueReportStatusChipProps {
    label: 'open' | 'in progress' | 'on hold' | 'done';
}

const IssueReportStatusChip = (props: IssueReportStatusChipProps) => {
    const labelColor = setIssueReportChipColor(props.label);
    const backgroundColor = hexToRgba(labelColor, 0.15);
    const { t } = useTranslation();

    const statuses = {
        open: 'open',
        done: 'resolved',
        'in progress': 'in_progress',
        'on hold': 'on_hold',
    };
    return (
        <Chip
            avatar={
                <span
                    style={{
                        backgroundColor: labelColor,
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        display: 'inline-block',
                    }}
                />
            }
            label={t(`issue_reports.card.${statuses[props.label]}`)}
            size={'small'}
            sx={{ backgroundColor, color: labelColor, fontWeight: 'bold', paddingX: '3px' }}
        />
    );
};

export default IssueReportStatusChip;
